import { API } from '@/api/Api'

import {
  GetALMInfo,
  GetALMSummary,
  GetALMLoans,
  GetALMDeposits,
  GetALMInvestments,
  GetAvailableDates
} from '@/api/query/ALM.graphql'

export default {
  // Queries
  async GetALMInfo (accountId) {
    const Data = { accountId: accountId }

    return await API.GQLRequest(GetALMInfo, Data)
  },

  async GetAvailableDates (accountId) {
    const Data = { accountId: accountId }

    return await API.GQLRequest(GetAvailableDates, Data)
  },

  async GetALMSummary (accountId, selectedDate) {
    const Data = { accountId: accountId }
    if (selectedDate) {
      Data.selectedDate = selectedDate
    }

    return await API.GQLRequest(GetALMSummary, Data)
  },

  async GetALMLoans (accountId, selectedDate) {
    const Data = { accountId: accountId }
    if (selectedDate) {
      Data.selectedDate = selectedDate
    }

    return await API.GQLRequest(GetALMLoans, Data)
  },

  async GetALMDeposits (accountId, selectedDate) {
    const Data = { accountId: accountId }
    if (selectedDate) {
      Data.selectedDate = selectedDate
    }

    return await API.GQLRequest(GetALMDeposits, Data)
  },

  async GetALMInvestments (accountId, selectedDate) {
    const Data = { accountId: accountId }
    if (selectedDate) {
      Data.selectedDate = selectedDate
    }

    return await API.GQLRequest(GetALMInvestments, Data)
  }
}
